<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div class="dispatch-list row">
          <b-button variant="none" @click="back">
            <i class="fa fa-chevron-left"></i>
            Back
          </b-button>
        </div>
        <b-card :header="'Site Config Setup'" class="mt-1">
          <b-alert :show="isShowAlert" variant="success" isShowAlert="false">
            <p>
              Save Successfully
              <b-button
                v-show="buttonishow"
                variant="primary"
                @click="reload"
                size="sm"
              >
                <i class="fa fa-arrow-left"></i>&nbsp;Go Back
              </b-button>
            </p>
          </b-alert>

          <b-form @submit="onSubmit" v-if="!isShowAlert" autocomplete="off">
            <b-alert :show="errors.length > 0" variant="danger">
              <h6 class="alert-heading">Please fill in all required field!</h6>
              <ul>
                <li v-for="(error, i) in errors" :key="`error-${i}`">
                  {{ error }}
                </li>
              </ul>
            </b-alert>

            <b-form-row>
              <b-col>
                <div class="form-group">
                  <label>Inbound Dwell Time</label>
                  <b-row>
                    <input
                      type="number"
                      v-model.trim="form.InboundDwell"
                      class="form-control w-75 mb-2 mr-sm-2 mb-sm-2"
                      placeholder="Inbound Dwell Time"
                    />
                    <h2>Min/s.</h2>
                  </b-row>
                </div></b-col
              >
              <b-col>
                <div class="form-group">
                  <label>Inbound Dashboard Count</label>
                  <input
                    type="number"
                    v-model.trim="form.InboundDashboardCount"
                    class="form-control mb-2 mr-sm-2 mb-sm-2"
                    placeholder="Inbound Dashboard Count"
                  />
                </div>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <div class="form-group">
                  <label>Outbound Dwell Time</label>

                  <b-row>
                    <input
                      type="number"
                      v-model.trim="form.OutboundDwell"
                      class="form-control w-75 mb-2 mr-sm-2 mb-sm-2"
                      placeholder="Outbound Dwell Time"
                    />
                    <h2>Min/s.</h2>
                  </b-row>
                </div>
              </b-col>
              <b-col>
                <div class="form-group">
                  <label>Outbound Dashboard Count</label>
                  <input
                    type="number"
                    v-model.trim="form.OutboundDashboardCount"
                    class="form-control mb-2 mr-sm-2 mb-sm-2"
                    placeholder="Outbound Dashboard Count"
                  />
                </div>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col>
                <div class="form-group">
                  <label>Delivery Dwell Time</label>
                  <b-row>
                    <input
                      type="number"
                      v-model.trim="form.WarehouseDwell"
                      class="form-control w-75 mb-2 mr-sm-2 mb-sm-2"
                      placeholder="Delivery Dwell Time"
                    />
                    <h2>Min/s.</h2>
                  </b-row>
                </div>
              </b-col>
              <b-col>
                <div class="form-group">
                  <label>Delivery Dashboard Count</label>
                  <input
                    type="number"
                    v-model.trim="form.WarehouseDashboardCount"
                    class="form-control mb-2 mr-sm-2 mb-sm-2"
                    placeholder="Delivery Dashboard Count"
                  />
                </div>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <label>Status</label>
                <b-form-radio-group
                  v-model="selected"
                  :options="options"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-radio-group>
              </b-col>
            </b-form-row>

            <div class="dispatch-table">
              <b-button type="submit" variant="primary">
                <i class="fa fa-save"></i>
                Save
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
  
  <script>
import api from "../../services/api";
import miniToastr from "mini-toastr";
import axios from "axios";

miniToastr.init();
export default {
  data() {
    return {
      errors: [],
      checked: "",
      isDisabled: this.$route.params.id == undefined ? false : true,
      buttonishow: this.$route.params.id == undefined ? true : false,
      transTypeList: [],
      laneTypes: [],
      isShowAlert: false,

      form: {
        InboundDwell: "",
        InboundDashboardCount: "",
        OutboundDwell: "",
        OutboundDashboardCount: "",
        WarehouseDwell: "",
        WarehouseDashboardCount: "",
        brancode: this.$store.getters.selectedWarehouse,
        CreatedBy: this.$store.getters.user.emplId,
        Status: "Active",
      },
      selected: "Active",
      options: [
        { item: "Active", name: "Active" },
        { item: "Inactive", name: "Inactive" },
      ],
    };
  },

  methods: {
    onSubmit: function (evt) {
      evt.preventDefault();
      this.form.Status = this.selected;

      //console.log(this.form);
      axios
        .post(this.$store.state.IFMSURLlocal + "post-site-config", this.form)
        .then((resp) => {
          this.getData();
          this.isShowAlert = true;
          //   this.$store.commit("setLoading", false);
        })
        .catch(function (err) {
          miniToastr.error(err.response.data);
          api.httpMsg(this, err.response.status, err.response.data);
          this.$store.commit("setLoading", false);
        });
    },

    back: function () {
      this.$router.push("/Maintenance/638067084561296904");
    },

    reload: function () {
      this.$router.go(this.$router.currentRoute);
    },

    getData: function () {
      let self = this;
      self.$store.commit("setLoading", true);
      self.form.brancode = this.$store.state.selectedWarehouse;
      // console.log(this.$store.state.selectedWarehouse);

      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-site-config?branchcode=" +
            this.$store.state.selectedWarehouse
        )
        .then((resp) => {
          if (resp.data != null) {
            self.form = resp.data;
            this.selected =
              self.form.Status == null || self.form.Status == "Active  "
                ? "Active"
                : self.form.Status;
          }
          // self.$store.commit("setLoading", false);
        })
        .catch((err) => {
          api.httpMsg(self, err.status, err.data);
          this.$store.dispatch("logout").then(() => {
            localStorage.removeItem("vuex");
            localStorage.removeItem("token");
            this.$router.push("/login");
          });
          self.$store.commit("setLoading", false);
        });
    },
  },

  created: function () {
    this.getData();
  },
};
</script>